import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { Button } from "primereact/button";
import { Card } from "primereact/card";

import { uiActions } from "../../store/ui-slice";
import { courseCategoryActions } from "../../store/coursecategory-store/coursecategory-slice";

let restartPage = false;
const CourseCategoryForm = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isValid = useSelector(
    (state) => state.courseCategory.courseCategoryValidation
  );
  const auth = useSelector((state) => state.auth);
  const courseCategory = props.courseCategory;
  const notification = useSelector((state) => state.ui.notification);

  useEffect(() => {
    if (
      notification &&
      notification.status === "success" &&
      courseCategory.id > 0 &&
      restartPage
    ) {
      dispatch(courseCategoryActions.restartState());
      window.location.href = "/course/categories";
    }
  }, [courseCategory.id, dispatch, navigate, notification]);

  const onChangeHandler = (id, value) => {
    dispatch(courseCategoryActions.modifyPropertyValue({ id, value }));
    if (id === "name") {
      if (value !== "") {
        dispatch(courseCategoryActions.setFieldValid({ id, value: true }));
      } else {
        dispatch(courseCategoryActions.setFieldValid({ id, value: false }));
      }
    }
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();

    if (courseCategory.name === "") {
      dispatch(
        courseCategoryActions.setFieldValid({ id: "name", value: false })
      );
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    } else {
      dispatch(props.actionCourseCategory(courseCategory, auth.UserInfo.email));
      restartPage = true;
    }
  };
  const getFormErrorMessage = (id) => {
    return !isValid[id].isValid ? (
      <Message severity="warn" text={isValid[id].errorMessage} />
    ) : (
      <small className="p-warn">&nbsp;</small>
    );
  };
  return (
    <>
      <Card
        style={{
          backgroundColor: "#142f47",
          marginLeft: "0%",
          marginTop: "-16px",
          boxShadow: "none",
          height: "100%",
          width: "98%",
        }}
      >
        <form onSubmit={onSubmitHandler}>
          <div className="formgrid grid">
            <div className="field col-12 md:col-12">
              <label
                htmlFor="description"
                style={{ fontSize: "large", color: "#35c4dc" }}
              >
                Categoría:
              </label>
              <InputText
                id="name"
                value={courseCategory.category}
                onChange={(e) => onChangeHandler("category", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("category")}</div>
            </div>
          </div>
          <div className="formgrid grid">
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff" }}
              label="Regresar"
              icon="pi pi-arrow-left"
              className="p-button-danger"
              onClick={() => {
                navigate("/course/categories");
              }}
            />
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff", marginLeft: "1%" }}
              label="Guardar"
              className="p-button-success"
              icon={
                notification && notification.status === "pending"
                  ? "pi pi-spin pi-spinner"
                  : "pi pi-save"
              }
              disabled={notification && notification.status === "pending"}
            />
          </div>
        </form>
      </Card>
    </>
  );
};
export default CourseCategoryForm;
